define(
    'viewmodels/secured/libraries/columns',[
        "durandal/app",
        "viewmodels/ViewModel",
        "providers/dataprovider",
        "i19n!i19n/strings"
    ],
    function (app, ViewModel, dataProvider, i19n) {

        var vm = new ViewModel(
        {
            id: '',
            notify: {},
            reload: {},
            comboClick: {},
            i19n: i19n,

            listTaken: ko.observableArray([]),

            fieldId: ko.observable()
        });

        vm.activate = function () {
            return loadData();
        };
        vm.attached = function () {
            var self = this;

            self.$holder = $('<li class="placeholder" ><span>' + i19n.to.drophere + '</span></li>');
            self.$taken = $('#takenColumns');

            self.kendoSortTaken = self.$taken.kendoSortable({
                placeholder: self.$holder,
                connectWith: '#availableColumns'
            }).data('kendoSortable');


            //$(window).on("resize", _.debounce(resizeColumns, 250));

            //function resizeColumns() {

            //    //    otherElements = self.$grid.children().not(".k-grid-content"),
            //    //    otherElementsHeight = 0;
            //    //otherElements.each(function () {                    
            //    //    otherElementsHeight += $(this).outerHeight();
            //    //});

            //    var tbh = $("#content-libraries").outerHeight();
            //    tbh = $(".clearfix.form-actions").position().top;
            //    console.warn(tbh);
            //}
        };
        vm.saveClick = function () {
            var taken = _.filter(vm.kendoSortTaken.element.children(), function (itm) { return $(itm).attr("data-isIncluded") == "1"; });
            taken = _.map(taken, function (itm) {
                return {
                    documentFieldId: $(itm).attr("data-documentFieldId"),
                    fieldName: $(itm).attr("data-fieldName")
                };
            });

            dataProvider.libraries
            .updateDisplay(vm.id, taken)
            .done(function (data) {
                //self.comboClick(self.id);
                vm.notify('success', i19n.to.columnsettings + ' ' + i19n.to.updated);
            })
            .fail(function (e) {
                vm.notify(e.error);
            });
        };
        vm.resetClick = function () {
            dataProvider.libraries
            .resetColumns(vm.id)
            .done(function (data) {
                vm.comboClick(vm.id);
                vm.notify('success', i19n.to.columnsettings + ' ' + i19n.to.settodefault);
            })
            .fail(function (e) {
                vm.notify(e.error);
            });
        };
        vm.cancelClick = function () {
            vm.comboClick(vm.id);
            //loadData();
        };

        return vm;

        function loadData() {
            return dataProvider.libraries
                .getDisplay(vm.id)
                .done(function (data) {
                    var taken = _.filter(data.columnsToDisplay, function (itm) { return itm.fieldName.length > 0; });

                    taken = _.map(taken, function (itm) {
                        itm.text = itm.fieldName;
                        itm.value = itm.documentFieldId;
                        itm.isIncluded = ko.observable(true);

                        return itm;
                    });

                    _.map(data.availableColumns, function (itm) {
                        itm.text = itm.fieldName;
                        itm.value = itm.documentFieldId;
                        itm.isIncluded = ko.observable(false);

                        taken.push(itm);
                    });

                    vm.listTaken(taken);
                })
                .fail(function (e) {
                    vm.notify(e.error);
                });
        }
    }
);
